@let isPostPayment = isPostPayment$ | async;
@let canBuy = Permissions.LicenseBuy | can: 'read';

<mbs-modal
  [title]="(isPostPayment ? 'shared:computers.license.assignLicense' : 'shared:computers.license.buyLicense') | i18next"
  [isCustomModal]="true"
  [showFooter]="true"
  [titleTextOverflow]="true"
  [size]="MbsSize.xl"
  #modal>
  <ng-container modal-body>
    <div>
      @if (isPostPayment) {
        {{ 'shared:computers.license.rmmCEPostPaymentAlert' | i18next }}
      } @else {
        {{ 'shared:computers.license.rmmCEPrePaymentAlert' | i18next }}
      }
    </div>
  </ng-container>
  <ng-container modalFooter>
    @if (canBuy) {
      <mbs-button
        type="primary"
        [loading]="loading"
        (click)="handleOk()">
        @if (isPostPayment) {
          {{ 'shared:buttons.assign' | i18next }}
        } @else {
          {{ 'shared:buttons.buy' | i18next }}
        }
      </mbs-button>
    }
    <mbs-button
      type="secondary"
      data-dismiss="modal"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
